"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoShape = exports.videoPlayerShape = exports.productInfoShape = exports.liquidPixelShape = exports.imageShape = exports.galleryTheme = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

// clean up the unneccessary shapes out of here
var galleryThumbTheme = _propTypes["default"].shape({
  margin: _propTypes["default"].string,
  opacity: _propTypes["default"].number,
  selected: _propTypes["default"].shape({
    border: _propTypes["default"].string,
    opacity: _propTypes["default"].number,
    overlay: _propTypes["default"].string
  }),
  hover: _propTypes["default"].shape({
    opacity: _propTypes["default"].number,
    border: _propTypes["default"].string
  }),
  remaining: _propTypes["default"].shape({
    show: _propTypes["default"].bool,
    text: _propTypes["default"].string,
    background: _propTypes["default"].string,
    border: _propTypes["default"].string,
    font: _propTypes["default"].shape({
      family: _propTypes["default"].string,
      color: _propTypes["default"].string,
      size: _propTypes["default"].string
    })
  }),
  video: _propTypes["default"].shape({
    className: _propTypes["default"].string,
    text: _propTypes["default"].string,
    style: _propTypes["default"].oneOf(['Overlay', 'Link'])
  }),
  max: _propTypes["default"].number
});

var galleryTabsTheme = _propTypes["default"].shape({
  border: _propTypes["default"].shape({
    color: _propTypes["default"].string,
    width: _propTypes["default"].string
  }),
  active: _propTypes["default"].string,
  color: _propTypes["default"].string,
  background: _propTypes["default"].string,
  padding: _propTypes["default"].string,
  fontWeight: _propTypes["default"].number
});

var galleryModalTheme = _propTypes["default"].shape({});

var galleryTheme = _propTypes["default"].shape({
  thumbnail: galleryThumbTheme,
  useTabs: _propTypes["default"].bool,
  ratio: _propTypes["default"].shape({
    width: _propTypes["default"].number,
    height: _propTypes["default"].number
  }),
  modalTabs: _propTypes["default"].oneOf(['all', 'separate', 'none']),
  modal: galleryModalTheme,
  showTitle: _propTypes["default"].bool,
  tabs: galleryTabsTheme,
  changeOnHover: _propTypes["default"].bool
});

exports.galleryTheme = galleryTheme;

var imageShape = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
  thumbnail: _propTypes["default"].string,
  primaryLink: _propTypes["default"].string,
  description: _propTypes["default"].string,
  sizes: _propTypes["default"].objectOf(_propTypes["default"].string)
})]);

exports.imageShape = imageShape;

var videoShape = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
  videoId: _propTypes["default"].string,
  thumbnail: _propTypes["default"].string,
  sizes: _propTypes["default"].objectOf(_propTypes["default"].string)
})]);

exports.videoShape = videoShape;

var productInfoShape = _propTypes["default"].shape({
  brand: _propTypes["default"].string,
  siteProductName: _propTypes["default"].string
});

exports.productInfoShape = productInfoShape;

var videoPlayerShape = _propTypes["default"].shape({
  videoPlayer: _propTypes["default"].string.isRequired,
  accountId: _propTypes["default"].string.isRequired,
  classNames: _propTypes["default"].string,
  playerId: _propTypes["default"].string,
  productId: _propTypes["default"].string,
  tag: _propTypes["default"].string
});

exports.videoPlayerShape = videoPlayerShape;

var liquidPixelShape = _propTypes["default"].shape({
  baseDomain: _propTypes["default"].string,
  className: _propTypes["default"].string,
  chain: _propTypes["default"].string,
  zoomEnabled: _propTypes["default"].bool,
  visualizationCallback: _propTypes["default"].func,
  minimized: _propTypes["default"].bool
});

exports.liquidPixelShape = liquidPixelShape;